import { EnumSchema, FromSchema, ZodDate } from '@40seas/entities/common';
import { Currency } from '@40seas/models';
import { z } from 'zod';
import { ConnectedAccountActivitySourceType } from './connected-account.activity.source.type.enum';
import { ConnectedAccountActivityStatus } from './connected-account.activity.status.enum';
import { ConnectedAccountActivityTransactionType } from './connected-account.activity.transaction.type.enum';

export const ConnectedAccountActivitySchema = z
    .object({
        transactionType: EnumSchema(ConnectedAccountActivityTransactionType),
        status: EnumSchema(ConnectedAccountActivityStatus),
        sourceType: EnumSchema(ConnectedAccountActivitySourceType),
        sourceId: z.string(),
        settledAt: ZodDate,
        netAmount: z.number(),
        id: z.string(),
        fundingSourceId: ZodDate,
        fee: z.number(),
        estimatedSettledAt: ZodDate,
        description: z.string(),
        currencyPair: z.string(),
        currency: EnumSchema(Currency),
        createdAt: ZodDate,
        clientRate: z.number(),
        batchId: z.string(),
        amount: z.number(),
    })
    .strict();

export class ConnectedAccountActivity extends FromSchema(ConnectedAccountActivitySchema) {
    amount: number;
    batchId: string;
    clientRate: number;
    createdAt: Date;
    currency: Currency;
    currencyPair: string;
    description: string;
    estimatedSettledAt: Date;
    fee: number;
    fundingSourceId: string;
    id: string;
    netAmount: number;
    settledAt: Date;
    sourceId: string;
    sourceType: ConnectedAccountActivitySourceType;
    status: ConnectedAccountActivityStatus;
    transactionType: ConnectedAccountActivityTransactionType;
}
